import { render, staticRenderFns } from "./NotificationsWrapper.vue?vue&type=template&id=3c1331ef"
import script from "./NotificationsWrapper.vue?vue&type=script&lang=ts"
export * from "./NotificationsWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c1331ef')) {
      api.createRecord('3c1331ef', component.options)
    } else {
      api.reload('3c1331ef', component.options)
    }
    module.hot.accept("./NotificationsWrapper.vue?vue&type=template&id=3c1331ef", function () {
      api.rerender('3c1331ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notification/NotificationsWrapper.vue"
export default component.exports